import React from "react";
import { Provider } from "react-redux";
import reducer from "./redux/notificationsReducer";
import rootSaga from "./redux/notificationsSagas";
import ErrorBoundary from "../../../components/errorBoundary/errorBoundary";
import { createReduxStore } from "../../../utils/createReduxStore";
import { NotificationsModule } from "./NotificationsModule";
import PropTypes from "prop-types";

const Notifications = (props) => {
  const { organizations, notifications } = props;

  const params = { organizations };

  return (
    <Provider store={createReduxStore(reducer, "notifications", rootSaga)}>
      <ErrorBoundary moduleName="notifications" {...notifications}>
        <NotificationsModule params={params} />
      </ErrorBoundary>
    </Provider>
  );
};

Notifications.propTypes = {
  organizations: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string
    })
  ),
  notifications: PropTypes.object
};

export default Notifications;
